import _ from 'lodash'

/**
 * This is a voucher that is applied automatically to Barmer users, allowing them to redeem a freebie right after login
 * Then after automatic redemption, they would be redirected to post-login, skipping the checkout flow
 */
export const BARMER_VOUCHER = 'gymbmr2025coop'

export const ExperimentName = {
    ORGANIC_PRICING: 'organic-pricing-experiment',
}

const defaultChannelConfig = {
    aliases: [],
    header: {
        title: 'checkout-package.title',
        subtitles: [
            'checkout-package.subtitle.1',
            'checkout-package.subtitle.2.dynamic',
            'checkout-package.subtitle.3',
        ],
        freebieTitle: 'checkout-package.freebieTitle',
    },
    advantages: {
        title: 'checkout.advantages.title',
        desktop: [
            {
                messageBase: 'checkout.advantages.flexibility',
                itemsNumber: 3,
            },
            {
                messageBase: 'checkout.advantages.offer',
                itemsNumber: 3,
            },
            {
                messageBase: 'checkout.advantages.quality',
                itemsNumber: 3,
            },
        ],
        mobile: [
            {
                messageBase: 'checkout.advantages.mobile',
                itemsNumber: 5,
            },
        ],
    },
    showShopVoucher: true,
}

export const channelNamesWithNoDiscountRibbon = ['ireland']

export const channelIdsWithNoDiscountRibbon = [
    82,
    83,
    84,
    85,
    86,
    88,
    101,
    140,
    174,
    185,
    236,
    336,
    359,
    363,
    367,
    369,
    372,
    374,
    383,
    388,
    420,
    431,
    432,
    433,
    452,
    454,
    466,
    503,
    515,
    518,
    541,
    543,
    544,
    547,
    600,
    601,
    602,
    635,
    636,
    637,
    638,
    641,
    642,
    643,
    644,
    645,
    646,
    647,
    648,
    649,
    650,
]

const configs = {
    default: defaultChannelConfig,
    sot: {
        channelId: 1,
        aliases: ['sophia', 'sofia', 'sopiha'],
        advantages: {
            desktop: [
                {
                    messageBase: 'sot.checkout.advantages.flexibility',
                    itemsNumber: 4,
                },
                {
                    messageBase: 'sot.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'sot.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'sot.checkout.advantages.mobile',
                    itemsNumber: 6,
                },
            ],
        },
        homepage: 'https://www.sophia-thiel.com',
    },
    ivana: { channelId: 2 },
    mdk: {
        channelId: 3,
        advantages: {
            desktop: [
                {
                    messageBase: 'mdk.checkout.advantages.flexibility',
                    itemsNumber: 4,
                },
                {
                    messageBase: 'mdk.checkout.advantages.offer',
                    itemsNumber: 4,
                },
                {
                    messageBase: 'mdk.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'mdk.checkout.advantages.mobile',
                    itemsNumber: 6,
                },
            ],
        },
        homepage: 'https://www.machdichkrass.de',
    },
    mtc: {
        channelId: 5,
        advantages: {
            desktop: [
                {
                    messageBase: 'mtc.checkout.advantages.flexibility',
                    itemsNumber: 4,
                },
                {
                    messageBase: 'mtc.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'mtc.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'mtc.checkout.advantages.mobile',
                    itemsNumber: 6,
                },
            ],
        },
        homepage: 'https://www.make-the-change.de',
    },
    adrienne: {
        channelId: 6,
        aliases: ['adriene'],
    },
    cathy: {
        channelId: 7,
        aliases: ['hummels'],
        advantages: {
            desktop: [
                {
                    messageBase: 'cathy.checkout.advantages.flexibility',
                    itemsNumber: 4,
                },
                {
                    messageBase: 'cathy.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'cathy.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'cathy.checkout.advantages.mobile',
                    itemsNumber: 6,
                },
            ],
        },
    },
    paola: {
        channelId: 8,
        advantages: {
            desktop: [
                {
                    messageBase: 'paola.checkout.advantages.flexibility',
                    itemsNumber: 4,
                },
                {
                    messageBase: 'paola.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'paola.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'paola.checkout.advantages.mobile',
                    itemsNumber: 6,
                },
            ],
        },
    },
    harrison: {
        channelId: 9,
        advantages: {
            title: 'harrison.checkout.advantages.title',
            desktop: [
                {
                    messageBase: 'harrison.checkout.advantages.flexibility',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'harrison.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'harrison.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'harrison.checkout.advantages.mobile',
                    itemsNumber: 6,
                },
            ],
        },
    },
    lisa: {
        channelId: 10,
        advantages: {
            desktop: [
                {
                    messageBase: 'lisa.checkout.advantages.flexibility',
                    itemsNumber: 4,
                },
                {
                    messageBase: 'lisa.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'lisa.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'lisa.checkout.advantages.mobile',
                    itemsNumber: 6,
                },
            ],
        },
    },
    ursula: { channelId: 11 },
    andrea: {
        channelId: 12,
        advantages: {
            title: 'andrea.checkout.advantages.title',
            desktop: [
                {
                    messageBase: 'andrea.checkout.advantages.flexibility',
                    itemsNumber: 4,
                },
                {
                    messageBase: 'andrea.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'andrea.checkout.advantages.quality',
                    itemsNumber: 2,
                },
            ],
            mobile: [
                {
                    messageBase: 'andrea.checkout.advantages.mobile',
                    itemsNumber: 6,
                },
            ],
        },
    },
    labrant: {
        channelId: 13,
        advantages: {
            title: 'labrant.checkout.advantages.title',
            desktop: [
                {
                    messageBase: 'labrant.checkout.advantages.flexibility',
                    itemsNumber: 4,
                },
                {
                    messageBase: 'labrant.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'labrant.checkout.advantages.quality',
                    itemsNumber: 2,
                },
            ],
            mobile: [
                {
                    messageBase: 'labrant.checkout.advantages.mobile',
                    itemsNumber: 6,
                },
            ],
        },
    },
    decathlon: {
        channelId: 14,
        homepage: 'https://training.gymondo.de/decathlon',
    },
    mediamarkt: {
        channelId: 15,
        homepage: 'https://training.gymondo.de/MSH',
    },
    vanessa: {
        channelId: 16,
        advantages: {
            title: 'vanessa.checkout.advantages.title',
            desktop: [
                {
                    messageBase: 'vanessa.checkout.advantages.flexibility',
                    itemsNumber: 4,
                },
                {
                    messageBase: 'vanessa.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'vanessa.checkout.advantages.quality',
                    itemsNumber: 2,
                },
            ],
            mobile: [
                {
                    messageBase: 'vanessa.checkout.advantages.mobile',
                    itemsNumber: 6,
                },
            ],
        },
    },
    lisa2: {
        channelId: 17,
        advantages: {
            title: 'lisa2.checkout.advantages.title',
            desktop: [
                {
                    messageBase: 'lisa2.checkout.advantages.flexibility',
                    itemsNumber: 4,
                },
                {
                    messageBase: 'lisa2.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'lisa2.checkout.advantages.quality',
                    itemsNumber: 2,
                },
            ],
            mobile: [
                {
                    messageBase: 'lisa2.checkout.advantages.mobile',
                    itemsNumber: 6,
                },
            ],
        },
    },
    levelup: {
        channelId: 18,
        advantages: {
            title: 'levelup.checkout.advantages.title',
            desktop: [
                {
                    messageBase: 'levelup.checkout.advantages.lifestyle',
                    itemsNumber: 4,
                },
                {
                    messageBase: 'levelup.checkout.advantages.program',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'levelup.checkout.advantages.success',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'levelup.checkout.advantages.mobile',
                    itemsNumber: 6,
                },
            ],
        },
    },
    totalbody: {
        channelId: 21,
        advantages: {
            title: 'totalbody.checkout.advantages.title',
            desktop: [
                {
                    messageBase: 'totalbody.checkout.advantages.flexibility',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'totalbody.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'totalbody.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'totalbody.checkout.advantages.mobile',
                    itemsNumber: 5,
                },
            ],
        },
    },
    healthyinsideout: {
        channelId: 22,
        advantages: {
            title: 'healthyinsideout.checkout.advantages.title',
            desktop: [
                {
                    messageBase:
                        'healthyinsideout.checkout.advantages.flexibility',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'healthyinsideout.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'healthyinsideout.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'healthyinsideout.checkout.advantages.mobile',
                    itemsNumber: 6,
                },
            ],
        },
    },
    maishape: {
        channelId: 23,
        advantages: {
            title: 'maishape.checkout.advantages.title',
            desktop: [
                {
                    messageBase: 'maishape.checkout.advantages.flexibility',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'maishape.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'maishape.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'maishape.checkout.advantages.mobile',
                    itemsNumber: 5,
                },
            ],
        },
    },
    shape360: {
        channelId: 247,
        advantages: {
            title: 'shape360.checkout.advantages.title',
            desktop: [
                {
                    messageBase: 'shape360.checkout.advantages.flexibility',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'shape360.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'shape360.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'shape360.checkout.advantages.mobile',
                    itemsNumber: 5,
                },
            ],
        },
    },
    pureflow: {
        channelId: 248,
        advantages: {
            title: 'pureflow.checkout.advantages.title',
            desktop: [
                {
                    messageBase: 'pureflow.checkout.advantages.flexibility',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'pureflow.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'pureflow.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'pureflow.checkout.advantages.mobile',
                    itemsNumber: 5,
                },
            ],
        },
    },
    danceworks: {
        channelId: 325,
        advantages: {
            title: 'danceworks.checkout.advantages.title',
            desktop: [
                {
                    messageBase: 'danceworks.checkout.advantages.flexibility',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'danceworks.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'danceworks.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'danceworks.checkout.advantages.mobile',
                    itemsNumber: 5,
                },
            ],
        },
    },
    strongmindbody: {
        channelId: 326,
        advantages: {
            title: 'strongmindbody.checkout.advantages.title',
            desktop: [
                {
                    messageBase:
                        'strongmindbody.checkout.advantages.flexibility',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'strongmindbody.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'strongmindbody.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'strongmindbody.checkout.advantages.mobile',
                    itemsNumber: 5,
                },
            ],
        },
    },
    maishorties: {
        channelId: 327,
        advantages: {
            title: 'maishorties.checkout.advantages.title',
            desktop: [
                {
                    messageBase: 'maishorties.checkout.advantages.flexibility',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'maishorties.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'maishorties.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'maishorties.checkout.advantages.mobile',
                    itemsNumber: 5,
                },
            ],
        },
    },
    power: {
        channelId: 328,
        advantages: {
            title: 'power.checkout.advantages.title',
            desktop: [
                {
                    messageBase: 'power.checkout.advantages.flexibility',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'power.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'power.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'power.checkout.advantages.mobile',
                    itemsNumber: 4,
                },
            ],
        },
    },
    elliHoop: {
        channelId: 347,
        shopProduct:
            // eslint-disable-next-line max-len
            'https://shop.gymondo.com/products/ellis-hoop?utm_medium=link&utm_source=checkout_ellihoop&utm_campaign=footer_link',
        advantages: {
            title: 'elliHoop.checkout.advantages.title',
            desktop: [
                {
                    messageBase: 'elliHoop.checkout.advantages.flexibility',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'elliHoop.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'elliHoop.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'elliHoop.checkout.advantages.mobile',
                    itemsNumber: 3,
                },
            ],
        },
        shopBanner: {
            title: 'elliHoop.checkout.shop.banner.title',
            banner: [
                {
                    messageBase: 'elliHoop.checkout.shop.highlights',
                    itemsNumber: 3,
                },
            ],
        },
    },
    campaign24M: {
        ...defaultChannelConfig,
        channelId: 451,
        disableVouchers: true,
    },
    summerShape: {
        ...defaultChannelConfig,
        channelId: 503,
    },
    strongerTogether: {
        channelId: 548,
        advantages: {
            title: 'strongertogether.checkout.advantages.title',
            desktop: [
                {
                    messageBase:
                        'strongertogether.checkout.advantages.flexibility',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'strongertogether.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'strongertogether.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'strongertogether.checkout.advantages.mobile',
                    itemsNumber: 5,
                },
            ],
        },
    },
    crmTest1: {
        ...defaultChannelConfig,
        channelId: 554,
        disableVouchers: true,
        showShopVoucher: false,
    },
    crmTest2: {
        ...defaultChannelConfig,
        channelId: 555,
        showShopVoucher: false,
    },
    frauke: {
        ...defaultChannelConfig,
        channelId: 549,
        advantages: {
            title: 'frauke.checkout.advantages.title',
            desktop: [
                {
                    messageBase: 'frauke.checkout.advantages.flexibility',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'frauke.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'frauke.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'frauke.checkout.advantages.mobile',
                    itemsNumber: 4,
                },
            ],
        },
    },
    pricingExperimentOrganicA: {
        ...defaultChannelConfig,
        channelId: 585,
        experimentName: ExperimentName.ORGANIC_PRICING,
        experimentVariant: 0,
        voucher: 'organic-a',
    },
    pricingExperimentOrganicB: {
        ...defaultChannelConfig,
        channelId: 586,
        experimentName: ExperimentName.ORGANIC_PRICING,
        experimentVariant: 1,
        voucher: 'organic-b',
    },
    pricingExperimentOrganicC: {
        ...defaultChannelConfig,
        channelId: 587,
        experimentName: ExperimentName.ORGANIC_PRICING,
        experimentVariant: 2,
        voucher: 'organic-c',
    },
    kisu: {
        ...defaultChannelConfig,
        channelId: 128,
        advantages: {
            title: 'kisu.checkout.advantages.title',
            desktop: [
                {
                    messageBase: 'kisu.checkout.advantages.flexibility',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'kisu.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'kisu.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'kisu.checkout.advantages.mobile',
                    itemsNumber: 3,
                },
            ],
        },
    },
    crmTestB: {
        ...defaultChannelConfig,
        channelId: 617,
        showShopVoucher: false,
        hideDiscount: true,
    },
    crmTestC: {
        ...defaultChannelConfig,
        channelId: 618,
        showShopVoucher: false,
    },
    jolina: {
        ...defaultChannelConfig,
        channelId: 448,
    },
    marisaHart: {
        ...defaultChannelConfig,
        channelId: 518,
        hideDiscount: true,
    },
    men: {
        ...defaultChannelConfig,
        channelId: 659,
    },
    merle: {
        ...defaultChannelConfig,
        channelId: 711,
        advantages: {
            title: 'merle.checkout.advantages.title',
            desktop: [
                {
                    messageBase: 'merle.checkout.advantages.flexibility',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'merle.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'merle.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'merle.checkout.advantages.mobile',
                    itemsNumber: 3,
                },
            ],
        },
    },
    fiona: {
        ...defaultChannelConfig,
        channelId: 918,
        header: {
            title: 'fiona.checkout-package.title',
            itemsNumber: 2,
            subtitles: [
                'fiona.checkout-package.subtitle.1',
                'fiona.checkout-package.subtitle.2',
            ],
        },
        advantages: {
            title: 'fiona.checkout.advantages.title',
            desktop: [
                {
                    messageBase: 'fiona.checkout.advantages.flexibility',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'fiona.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'fiona.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'fiona.checkout.advantages.mobile',
                    itemsNumber: 3,
                },
            ],
        },
    },
    fiona2: {
        ...defaultChannelConfig,
        channelId: 459,
        advantages: {
            title: 'fiona.checkout.advantages.title',
            desktop: [
                {
                    messageBase: 'fiona.checkout.advantages.flexibility',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'fiona.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'fiona.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'fiona.checkout.advantages.mobile',
                    itemsNumber: 3,
                },
            ],
        },
    },
    lola: {
        ...defaultChannelConfig,
        channelId: 328,
        advantages: {
            title: 'lola.checkout.advantages.title',
            desktop: [
                {
                    messageBase: 'lola.checkout.advantages.flexibility',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'lola.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'lola.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'lola.checkout.advantages.mobile',
                    itemsNumber: 3,
                },
            ],
        },
    },
    josephinewelsch: {
        ...defaultChannelConfig,
        channelId: 465,
    },
    bodyformus: {
        ...defaultChannelConfig,
        channelId: 702,
        advantages: {
            title: 'bodyformus.checkout.advantages.title',
            desktop: [
                {
                    messageBase: 'bodyformus.checkout.advantages.flexibility',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'bodyformus.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'bodyformus.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'bodyformus.checkout.advantages.mobile',
                    itemsNumber: 3,
                },
            ],
        },
    },
    juliaJoey: {
        ...defaultChannelConfig,
        channelId: 639,
        advantages: {
            title: 'juliaJoey.checkout.advantages.title',
            desktop: [
                {
                    messageBase: 'juliaJoey.checkout.advantages.flexibility',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'juliaJoey.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'juliaJoey.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'juliaJoey.checkout.advantages.mobile',
                    itemsNumber: 2,
                },
            ],
        },
    },
    datjulschen: {
        ...defaultChannelConfig,
        channelId: 165,
        advantages: {
            title: 'datjulschen.checkout.advantages.title',
            desktop: [
                {
                    messageBase: 'datjulschen.checkout.advantages.flexibility',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'datjulschen.checkout.advantages.offer',
                    itemsNumber: 3,
                },
                {
                    messageBase: 'datjulschen.checkout.advantages.quality',
                    itemsNumber: 3,
                },
            ],
            mobile: [
                {
                    messageBase: 'datjulschen.checkout.advantages.mobile',
                    itemsNumber: 5,
                },
            ],
        },
    },
    lefloid: {
        ...defaultChannelConfig,
        channelId: 504,
    },
    intersport: {
        ...defaultChannelConfig,
        channelId: 714,
    },
    corporatebenefits12m: {
        ...defaultChannelConfig,
        channelId: 804,
    },
    corporatebenefits1m: {
        ...defaultChannelConfig,
        channelId: 805,
        disableVouchers: true,
    },
    gymondoShop:
        'https://shop.gymondo.com/?utm_medium=link&utm_source=checkout&utm_campaign=footer_link',
}

const processedConfig = Object.keys(configs).reduce(
    (aggr, key) => {
        const { aliases } = configs[key]

        configs[key] = _.defaultsDeep(configs[key], configs.default)

        if (!aliases) {
            return aggr
        }

        aliases.forEach((alias) => {
            aggr[alias] = configs[key]
        })

        return aggr
    },
    { ...configs }
)

export const getChannelNameById = (id) =>
    Object.entries(processedConfig).find(
        ([, config]) => config.channelId === parseInt(id, 10)
    )?.[0]

export const getChannelConfigsByExperiment = (experimentName) => {
    if (!experimentName) {
        return []
    }

    return Object.entries(processedConfig)
        .filter(([, config]) => config.experimentName === experimentName)
        .map(([channelName, config]) => ({
            ...config,
            channelName,
        }))
}

export const getChannelNameByExperiment = (experimentName, variant) => {
    if (variant === null) {
        return undefined
    }

    return getChannelConfigsByExperiment(experimentName).find(
        (config) => config.experimentVariant === parseInt(variant, 10)
    )?.channelName
}

export const getExperimentChannelIds = (experimentName) =>
    getChannelConfigsByExperiment(experimentName).map(
        (config) => config.channelId
    )

export default processedConfig
